import { ActivityState } from './types'
import { Module } from 'vuex'
import { RootState } from '@/Common/store/types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

const namespaced: boolean = true

export const activity: Module<ActivityState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
